import { Link } from "react-router-dom";

const productLinks = [
  { label: "Features", href: "/#features" },
  { label: "AI Coach", href: "/#coach" },
  { label: "How it works", href: "/#howitworks" },
  { label: "Blog", to: "/blog" },
];

const policyLinks = [
  { label: "Terms of Use", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Security & Safety", to: "/safety-overview" },
  { label: "Data Removal", to: "/data-removal-policy" },
  { label: "Community Guidelines", to: "/community-guidelines" },
  { label: "Data Residency", to: "/data-residency" },
];

const supportLinks = [
  { label: "Contact us", href: "/contact" },
  { label: "support@bodylytix.ai", href: "mailto:support@bodylytix.ai" },
];

const PricingSoonLink = ({ onClick }) => (
  <Link className="bl-header-pricing-link" to="/pricing" onClick={onClick}>
    <span>Pricing</span>
    <span className="bl-header-pricing-link__badge">Soon</span>
  </Link>
);

const socialLinks = [
  {
    label: "Discord",
    href: "https://discord.gg/NssqZfs4",
    icon: <i className="fab fa-discord" aria-hidden="true" />,
  },
  {
    label: "X",
    href: "https://x.com/bodylytiX",
    icon: (
      <svg width="13" height="13" viewBox="0 0 512 512" aria-hidden="true">
        <path
          fill="currentColor"
          d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
        />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/bodylytix",
    icon: <i className="fab fa-instagram" aria-hidden="true" />,
  },
];

const FooterLink = ({ link }) =>
  link.to ? (
    <Link to={link.to}>{link.label}</Link>
  ) : (
    <a href={link.href}>{link.label}</a>
  );

const Footer1 = () => (
  <footer className="bl-footer">
    <div className="bl-footer__shell">
      <div className="bl-footer__top">
        <div className="bl-footer__brand-col">
          <Link className="bl-footer__brand" to="/">
            <img src="/assets/img/logo.svg" alt="" aria-hidden="true" />
            <span>BodyLytiX</span>
          </Link>
          <p>
            Personalized AI Insights. One place for your sleep, training,
            recovery and wellness data.
          </p>
          <div className="bl-footer__socials">
            {socialLinks.map((link) => (
              <a
                href={link.href}
                target="_blank"
                rel="noreferrer"
                aria-label={link.label}
                key={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="bl-footer__col">
          <div className="bl-footer__title">Product</div>
          <div className="bl-footer__links">
            {productLinks.map((link) => (
              <FooterLink link={link} key={link.label} />
            ))}
            <PricingSoonLink />
          </div>
        </div>

        <div className="bl-footer__col">
          <div className="bl-footer__title">Terms & Policies</div>
          <div className="bl-footer__links">
            {policyLinks.map((link) => (
              <FooterLink link={link} key={link.label} />
            ))}
          </div>
        </div>

        <div className="bl-footer__col">
          <div className="bl-footer__title">Support</div>
          <div className="bl-footer__links">
            {supportLinks.map((link) => (
              <FooterLink link={link} key={link.label} />
            ))}
          </div>
        </div>
      </div>

      <div className="bl-footer__bottom">
        <span>
          Copyright © {new Date().getFullYear()} BodyLytiX. All rights reserved.
        </span>
        <span>Dubai, UAE · support@bodylytix.ai</span>
      </div>
    </div>
  </footer>
);

export default Footer1;
